import * as Yup from 'yup';

import { jobApplicationsOptions as defaultJobApplicationsOptions } from '../../../defaultFilters';

export const useJobApplicationsFilter = ({ setFilters }) => {
  const jobApplicationsOptions = defaultJobApplicationsOptions;

  const formSchema = Yup.object().shape({
    jobApplications: Yup.object().shape({
      label: Yup.string().required(),
      value: Yup.mixed().nullable().defined(),
    }),
  });

  const onSubmit = ({ jobApplications }) => {
    setFilters(
      { jobApplications },
      {
        removeFilters: jobApplications?.value === 'any' ? ['jobApplications'] : [],
      },
    );
  };

  return {
    formSchema,
    onSubmit,
    jobApplicationsOptions,
  };
};
